import { Download } from 'lucide-react'
import { useTwaWrapperUpdate } from '@/hooks/useTwaWrapperUpdate'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'

/**
 * MultiPack Android/TWA wrapper update strip.
 * Never shown for ordinary web deploys or non-TWA browsers.
 */
export function TwaUpdateBanner({ className }: { className?: string }) {
  const { updateAvailable, latest, mandatory, dismiss, startUpdate } = useTwaWrapperUpdate()

  if (!updateAvailable || !latest) return null

  const note = latest.releaseNotes[0]
    ? latest.releaseNotes[0]
    : 'Android app improvements are ready.'

  return (
    <div
      role="status"
      className={cn(
        'flex shrink-0 flex-col gap-2 border-b border-amber-500/30 bg-amber-500/10 px-3 py-2.5 text-sm text-foreground sm:flex-row sm:items-center',
        className,
      )}
    >
      <div className="min-w-0 flex-1">
        <p className="font-semibold tracking-tight">MultiPack update available</p>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Version {latest.versionName} — {note}
          {mandatory ? ' This update is required.' : null}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {!mandatory ? (
          <Button type="button" variant="ghost" size="sm" className="h-8 px-3" onClick={dismiss}>
            Later
          </Button>
        ) : null}
        <Button type="button" size="sm" className="h-8 gap-1.5 px-3" onClick={startUpdate}>
          <Download className="h-3.5 w-3.5" aria-hidden />
          Update now
        </Button>
      </div>
    </div>
  )
}
